"use client";

import { useState, useRef, useEffect } from "react";
import Link from "next/link";
import {
  Handshake,
  Briefcase,
  Headphones,
  Users,
  Landmark,
  HeartPulse,
  GraduationCap,
  Scale,
  Home,
  Building2,
  ShoppingBag,
  Target,
  ChevronDown,
} from "lucide-react";

const sectors = [
  { name: "Sales & Fundraising", icon: Handshake, slug: "sales-fundraising" },
  { name: "B2B Sales Teams", icon: Briefcase, slug: "b2b-sales" },
  { name: "Klantenservice", icon: Headphones, slug: "klantenservice" },
  { name: "Recruitment & HR", icon: Users, slug: "recruitment-hr" },
  { name: "Financieel Advies", icon: Landmark, slug: "financieel-advies" },
  { name: "Gezondheidszorg", icon: HeartPulse, slug: "gezondheidszorg" },
  { name: "Onderwijs", icon: GraduationCap, slug: "onderwijs" },
  { name: "Juridisch", icon: Scale, slug: "juridisch" },
  { name: "Vastgoed", icon: Home, slug: "vastgoed" },
  { name: "Overheid", icon: Building2, slug: "overheid" },
  { name: "Horeca & Retail", icon: ShoppingBag, slug: "horeca-retail" },
  { name: "Coaching", icon: Target, slug: "coaching" },
];

export default function SectorenDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  };

  return (
    <div
      ref={ref}
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 rounded text-[13px] font-medium tracking-wide text-gray-300 transition-colors hover:text-white focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#030712] focus-visible:outline-none"
        aria-expanded={open}
        aria-haspopup="true"
      >
        Sectoren
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute top-full left-1/2 mt-3 w-[520px] -translate-x-1/2 rounded-xl border border-white/10 bg-gray-900/95 p-4 shadow-2xl backdrop-blur-xl">
          <div className="grid grid-cols-3 gap-1">
            {sectors.map((sector) => (
              <Link
                key={sector.slug}
                href={`/sectoren/${sector.slug}`}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2.5 rounded-lg px-3 py-2.5 transition-colors hover:bg-white/5"
              >
                <sector.icon className="h-4 w-4 shrink-0 text-blue-400" />
                <span className="text-[13px] font-medium text-gray-200">{sector.name}</span>
              </Link>
            ))}
          </div>
          <div className="mt-3 border-t border-white/5 pt-3">
            <Link
              href="/sectoren"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-1 text-[13px] font-medium text-blue-400 transition-colors hover:text-blue-300"
            >
              Alle sectoren bekijken →
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
